export default __webpack_public_path__ + "static/media/tbFormat1.a0557568.png";